import React from 'react'
import PropTypes from 'prop-types'
import { useGetComponentBlueprintByCode } from '../../../api/denali'
import Loading from '../../molecules/Loading'
import { componentTypeRegistry } from './componentTypeRegistry'

function SmartComponent ({ blueprintCode, presentationKey, minHeight, styleVariant: styleVariantOverride, styleVariantParams: styleVariantParamsOverride }) {
  const { data: blueprint, isLoading, error } = useGetComponentBlueprintByCode(blueprintCode, {
    includes: { definition: true }
  })

  const containerStyle = minHeight ? { minHeight } : undefined

  if (isLoading) {
    return (
      <div style={containerStyle}>
        <Loading />
      </div>
    )
  }

  if (error) {
    return (
      <div className='p-md font-size-sm' style={{ ...containerStyle, color: 'var(--color-danger-500)' }}>
        Failed to load component blueprint &quot;{blueprintCode}&quot;: {error.message ?? 'Unknown error'}
      </div>
    )
  }

  if (!blueprint) {
    return (
      <div className='p-md font-size-sm' style={{ ...containerStyle, color: 'var(--color-warning-500)' }}>
        Component blueprint &quot;{blueprintCode}&quot; not found
      </div>
    )
  }

  const definition = blueprint.definition
  if (!definition) {
    return (
      <div className='p-md font-size-sm' style={{ ...containerStyle, color: 'var(--color-warning-500)' }}>
        No active definition for blueprint &quot;{blueprintCode}&quot;
      </div>
    )
  }

  const presentations = definition.data?.presentations || {}
  const presentation = presentations[presentationKey]
  if (!presentation) {
    return (
      <div className='p-md font-size-sm' style={{ ...containerStyle, color: 'var(--color-warning-500)' }}>
        No presentation &quot;{presentationKey}&quot; found in blueprint &quot;{blueprintCode}&quot;
      </div>
    )
  }

  const typeEntry = componentTypeRegistry[presentation.componentType]
  if (!typeEntry) {
    return (
      <div className='p-md font-size-sm' style={{ ...containerStyle, color: 'var(--color-warning-500)' }}>
        Unknown component type &quot;{presentation.componentType}&quot; in presentation &quot;{presentationKey}&quot; of blueprint &quot;{blueprintCode}&quot;
      </div>
    )
  }

  const Renderer = typeEntry.renderer

  return (
    <div style={containerStyle}>
      <Renderer
        config={presentation.config}
        styleVariant={styleVariantOverride ?? presentation.styleVariant}
        styleVariantParams={styleVariantParamsOverride ?? presentation.styleVariantParams}
        presentationKey={presentationKey}
        blueprint={blueprint}
        displayName={presentation.displayName}
      />
    </div>
  )
}

SmartComponent.propTypes = {
  blueprintCode: PropTypes.string.isRequired,
  presentationKey: PropTypes.string.isRequired,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styleVariant: PropTypes.string,
  styleVariantParams: PropTypes.object
}

export default SmartComponent
